export enum EAudioZone {
  bpSpotRegionEx01 = 'bpSpotRegionEx01',
  bpSpotRegionExB01 = 'bpSpotRegionExB01',
  bpSpotRegionExB02 = 'bpSpotRegionExB02',
  bpSpotRegionExB03 = 'bpSpotRegionExB03',
  bpSpotRegionExB04 = 'bpSpotRegionExB04',
  bpSpotRegionExB05 = 'bpSpotRegionExB05',
  bpSpotRegionExB06 = 'bpSpotRegionExB06',
  bpSpotRegionExB07 = 'bpSpotRegionExB07',
  bpSpotRegionExB08 = 'bpSpotRegionExB08',
  bpSpotRegionExB09 = 'bpSpotRegionExB09',
  bpSpotRegionExB910 = 'bpSpotRegionExB910',
}

export const audioZoneScript: { [key in EAudioZone]: string } = {
  // auditorium entrance
  [EAudioZone.bpSpotRegionEx01]:
    'Hello, {{userName}}! Welcome to the AWS AI Certification Experience. I’m Noa, your Generative AI assistant powered by AWS technologies, including Bedrock, Nova, Polly, and Transcribe. Follow the 9 booths starting from the left of the floor, each covering a key topic. Let’s begin!',
  // auditorium booths
  [EAudioZone.bpSpotRegionExB01]:
    'This booth explores the basics of AI and how it simulates human intelligence. Let’s dive in!',
  [EAudioZone.bpSpotRegionExB02]:
    'Learn how AWS and cloud computing provide scalable, cost-effective IT solutions here.',
  [EAudioZone.bpSpotRegionExB03]:
    'Discover Amazon Bedrock and how AWS powers Generative AI applications effortlessly.',
  [EAudioZone.bpSpotRegionExB04]:
    'Explore how crafting the right prompts optimizes AI outputs in this booth.',
  [EAudioZone.bpSpotRegionExB05]:
    'Learn about Amazon Q, a service that simplifies deploying AI solutions at scale.',
  [EAudioZone.bpSpotRegionExB06]:
    'This booth covers AI, machine learning, and how they solve real-world problems.',
  [EAudioZone.bpSpotRegionExB07]:
    'Explore AWS AI services like recognition and Transcribe for your business needs.',
  [EAudioZone.bpSpotRegionExB08]:
    'Discover SageMaker, AWS tool for building and deploying machine learning models.',
  [EAudioZone.bpSpotRegionExB09]:
    'Learn about ethical AI practices, security, and compliance to ensure responsible AI use.',
  // celebration moment
  [EAudioZone.bpSpotRegionExB910]:
    'Congratulations, {{userName}}! You’ve completed the AWS AI Certification Experience. I’m thrilled to announce that you’ve successfully finished the program. You will now be teleported to the auditorium to receive your certification. Great job, and let’s move to your next destination!',
};

export const celebratoryMomentAudioZone = 'bpSpotRegionExB910';
